import axios from 'axios';
import { API_URL } from './config';

const apiClient = axios.create({
    baseURL: API_URL,
    // headers: {
    //     "Content-Type": "application/json",
    // },
});

// AM2-PATCH : duree maximale de session (24 h) controlee aussi cote navigateur ; le serveur reste l'autorite (401 Unauthorized!).
const SESSION_MAX_AGE_MS = 24 * 60 * 60 * 1000;
const isSessionTokenExpired = (token) => {
    try {
        const part = String(token).split('.')[1];
        if (!part) return false;
        const payload = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/')));
        const now = Date.now();
        if (payload.exp && payload.exp * 1000 <= now) return true;
        if (payload.iat && now - payload.iat * 1000 > SESSION_MAX_AGE_MS) return true;
        return false;
    } catch (e) {
        return false;
    }
};

apiClient.interceptors.request.use(
    config => {
        const token = localStorage.getItem('@accessToken');
        const isLoginCall = /\/login(\b|\/)/.test(config?.url || '');
        if (token && !isLoginCall && isSessionTokenExpired(token)) {
            localStorage.removeItem('@accessToken');
            localStorage.removeItem('@accessUser');
            localStorage.removeItem('@permissions');
            window.location.assign('/login');
            return Promise.reject(new Error('SESSION_EXPIREE'));
        }
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
            config.headers['x-access-token'] = token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Session expirée (jeton JWT invalide/expiré) ou compte désactivé en cours de
// session : on nettoie la session locale et on renvoie vers la page de
// connexion au lieu de laisser les écrans échouer silencieusement.
let sessionRedirecting = false;
apiClient.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status;
        const message = error?.response?.data?.message;
        const isLoginCall = /\/login(\b|\/)/.test(error?.config?.url || '');
        const sessionLost =
            (status === 401 && message === 'Unauthorized!') ||
            (status === 403 && message === 'accountDisabled');

        if (sessionLost && !isLoginCall && !sessionRedirecting) {
            sessionRedirecting = true;
            localStorage.removeItem('@accessToken');
            localStorage.removeItem('@accessUser');
            localStorage.removeItem('@permissions');
            window.location.assign('/login');
        }
        return Promise.reject(error);
    }
);

export default apiClient;